import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "order_show"
};
const _hoisted_2 = {
  class: "order_info"
};
const _hoisted_3 = {
  class: "order_xq"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_list = _resolveComponent("van-list");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_nav_bar, {
    title: "我的订单",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $setup.loading = $event),
    finished: $setup.finished,
    "finished-text": "没有更多了",
    onLoad: $setup.loadData
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, key) => {
      return _openBlock(), _createElementBlock("div", {
        class: "order_list",
        key: key
      }, [_createVNode(_component_router_link, {
        to: "/order/show?oid=" + item.oid
      }, {
        default: _withCtx(() => [_createElementVNode("dl", _hoisted_2, [_createElementVNode("dt", null, "订单号：" + _toDisplayString(item.oid), 1), _createElementVNode("dd", null, _toDisplayString(item.uptime), 1)]), _createElementVNode("ul", null, [_createElementVNode("li", null, _toDisplayString(item.name) + "/" + _toDisplayString(item.phone), 1), _createElementVNode("li", null, _toDisplayString(item.address), 1)]), _createElementVNode("dl", _hoisted_3, [_createElementVNode("dt", null, "￥" + _toDisplayString(item.price), 1), _createElementVNode("dd", null, [_createElementVNode("span", {
          class: _normalizeClass("status" + item.status)
        }, _toDisplayString(item.sname), 3)])])]),
        _: 2
      }, 1032, ["to"])]);
    }), 128))]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])])], 64);
}